<template>
  <div>
    <vx-card class="mb-4" title="Экспорт данных для ГИС ЖКХ">
      <div>
        <div class="vx-row mt-6">
          <div class="vx-col w-full xl:w-1/4 mb-4" v-if="$can('rp.gis', 'write')">
            <h5 class="mb-6">Отчеты</h5>
            <div class="text-lg mb-4" v-for="report in REPORTS_TYPES" :key="`report${report.id}`">
              <vs-radio v-model="selectedReport" :vs-value="report">
                {{ report.name }}
              </vs-radio>
              <app-datepicker
                v-if="report.selectMonth && selectedReport === report"
                class="mt-2"
                label="Выберите месяц"
                minimum-view="month"
                format="MMMM yyyy"
                v-model="month"
                :disabled-dates="fromLastMonth"
              />
            </div>
            <div class="flex justify-center w-full" v-if="selectedReport">
              <vs-button type="border" @click="generate">Сгенерировать</vs-button>
            </div>
          </div>
          <div class="vx-col w-full xl:w-3/4 mb-4" :class="[{'xl:w-full': !$can('rp.gis', 'write')}]">
            <h5 class="mb-6">История экспорта</h5>
            <vs-table
              :data="reportsHistory" max-items="5" pagination class="w-full"
              noDataText="История экспорта пуста" v-if="reportsHistory.length"
            >
              <template slot="thead">
                <vs-th>Дата</vs-th>
                <vs-th>Автор</vs-th>
                <vs-th>Имя файла</vs-th>
                <vs-th>Скачать</vs-th>
              </template>

              <template slot-scope="{data}" ref="content">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    {{ tr.created_at | moment('DD.MM.YYYY HH:mm:ss') }}
                  </vs-td>
                  <vs-td>
                    <span v-if="tr.user">{{ tr.user.name }}</span>
                  </vs-td>
                  <vs-td>
                    {{ tr.name }}
                  </vs-td>
                  <vs-td>
                    <a :href="tr.path | imgPath" :download="tr.name" target="_blank">
                      <feather-icon icon="DownloadIcon" svg-classes="text-primary" class="cursor-pointer" />
                    </a>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <h6 class="text-center" v-else>История экспорта пуста</h6>
          </div>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col mb-4 xl:w-1/3 w-full">
        <vx-card title="Импорт файла с идентификаторами ЕЛС">
          <div class="w-full flex justify-center">
            <elsa-v-upload v-model="importELSFile" file-type="excel" />
          </div>
          <div class="w-full text-center mt-4">
            <vs-button
              type="border"
              color="success"
              @click="uploadImportELSFile"
              :disabled="!importELSFile"
            >
              Загрузить
            </vs-button>
          </div>
        </vx-card>
      </div>
      <div class="vx-col mb-4 xl:w-1/3 w-full">
        <vx-card title="Импорт файла с идентификаторами приборов учетов">
          <div class="w-full flex justify-center">
            <elsa-v-upload v-model="importDevicesFile" file-type="excel" />
          </div>
          <div class="w-full text-center mt-4">
            <vs-button
              type="border"
              color="success"
              @click="uploadImportDeviceFile"
              :disabled="!importDevicesFile"
            >
              Загрузить
            </vs-button>
          </div>
        </vx-card>
      </div>
      <div class="vx-col mb-4 xl:w-1/3 w-full">
        <vx-card title="Импорт файла с идентификаторами платежных докуметов">
          <div class="w-full flex justify-center">
            <elsa-v-upload v-model="importPaymentsFile" file-type="excel" />
          </div>
          <div class="w-full text-center mt-4">
            <vs-button
              type="border"
              color="success"
              @click="uploadImportPaymentsFile"
              :disabled="!importPaymentsFile"
            >
              Загрузить
            </vs-button>
          </div>
        </vx-card>
      </div>
    </div>
    <gis-tariffs />
  </div>
</template>

<script>
import GisTariffs      from "@/components/employee/gis/gisTariffs";
import notifyHttpError from "../../../mixins/notifyHttpError";

const REPORTS_TYPES = [
  {
    id:     1,
    name:   'Отчет лицевых счетов',
    method: '/gis_accounts',
  },
  {
    id:     2,
    name:   'Отчет приборов',
    method: '/gis_devices',
  },
  {
    id:          3,
    name:        'Экспорт платежей',
    selectMonth: true,
    method:      '/gis_invoices',
  },
  {
    id:          4,
    name:        'Экспорт показаний',
    selectMonth: true,
    method:      '/gis_device_values',
  },
];

export default {
  name:       "GIS",
  components: { GisTariffs },
  mixins:     [notifyHttpError],
  data() {
    return {
      REPORTS_TYPES:  REPORTS_TYPES,
      selectedReport: null,
      reportsHistory: [],
      month:          null,

      importELSFile:      null,
      importDevicesFile:  null,
      importPaymentsFile: null,
    };
  },
  computed: {
    fromLastMonth() {
      const now = new Date();
      now.setMonth(now.getMonth() - 1);
      return {
        from: now,
      };
    },
    userId() {
      return this.$store.getters['appUser/id'];
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    async getHistory() {
      try {
        let { data } = await this.$http.get('gis_history', {
          params: {
            buildings_id: this.selectedHouseId,
          },
        });

        this.reportsHistory = data.files;
      } catch (e) {
        this.reportsHistory = [];
      }
    },
    async generate() {
      try {
        let body = {
          buildings_id: this.selectedHouseId,
          users_id:     this.userId,
        };

        if (this.selectedReport.selectMonth) {
          body.month = this.$options.filters.formatDate(this.month);
        }

        this.$vs.notify({ color: 'success', title: 'Генерация началась', text: 'Отчет появится в истории' });
        await this.$http.post(this.selectedReport.method, body);
        this.selectedReport = null;
        this.getHistory();
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    uploadImportELSFile() {
      let body = new FormData();
      body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
      body.append('file', this.importELSFile);
      this.$http.post('update_els_gis_room_number', body).then(( { data } ) => {
        if (data && data.hasOwnProperty('updated')) {
          return this.$vs.notify({
            color: 'success',
            title: 'Файл успешно загружен',
            text:  `Импортировано: ${data.updated}`,
          });
        }
        this.$vs.notify({ color: 'danger', title: 'Ошибка загрузки' });
      }, this.notifyHttpError).finally(() => {
        this.importELSFile = null;
      });
    },

    uploadImportDeviceFile() {
      let body = new FormData();
      body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
      body.append('file', this.importDevicesFile);
      this.$http.post('gis/devices/import', body).then(( { data } ) => {
        if (data && data.hasOwnProperty('updated')) {
          return this.$vs.notify({
            color: 'success',
            title: 'Файл успешно загружен',
            text:  `Импортировано: ${data.updated}`,
          });
        }
        this.$vs.notify({ color: 'danger', title: 'Ошибка загрузки' });
      }, this.notifyHttpError).finally(() => {
        this.importDevicesFile = null;
      });
    },

    uploadImportPaymentsFile() {
      let body = new FormData();
      body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
      body.append('file', this.importPaymentsFile);
      this.$http.post('gis/payments/import', body).then(( { data } ) => {
        return this.$vs.notify({
          color: 'success',
          title: 'Файл успешно загружен',
          text:  `Импортировано: ${data.identifiers_imported}/${data.rows_processed}`,
        });
      }, this.notifyHttpError).finally(() => {
        this.importPaymentsFile = null;
      });
    },
  },
  mounted() {
    this.getHistory();
    this.month = this.fromLastMonth.from;
  },
  watch: {
    selectedHouseId() {
      this.getHistory();
    },
  },
};
</script>
